module.exports = __webpack_public_path__ + "static/media/Group-2804-gold.823d35ac.svg";